export default [
    {
        name: 'word',
        sortField: 'word',
        type: 'string',
        callback: 'similarKeyWord',
        useInFilter: true,
        defaultSearch: true
    },
    {
        name: '__slot:url',
        sortField: 'url',
        type: 'string',
        dataClass: 'w300',
        useInFilter: true,
    },
    {
        name: '__slot:pos',
        sortField: 'pos',
        type: 'number',
        dataClass: 'ral pos',
        useInFilter: true,
    },
    {
        name: 'frequency',
        sortField: 'ws',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        isDefault: true,
        useInFilter: true,
    },
    {
        name: 'numwords',
        sortField: 'numwords',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'adscnt',
        sortField: 'adscnt',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'docs',
        sortField: 'docs',
        type: 'number',
        callback: 'number',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'mincpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'maxcpc',
        sortField: 'cpc_min',
        type: 'float',
        callback: 'float',
        dataClass: 'ral',
        useInFilter: true,
    },
    {
        name: 'serpf',
        sortField: 'serp',
        type: 'string',
        dataClass: 'ral',
        useInFilter: false,
    }
]
